import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-kb-list',
  templateUrl: './kb-list.component.html',
  styleUrls: ['./kb-list.component.scss']
})
export class KbListComponent implements OnInit, OnDestroy {
  articles: any[] = [];
  categories: any[] = [];
  role: string | null = null;
  loading = false;
  searchQuery = '';
  categoryFilter = '';
  currentPage = 1;
  totalCount = 0;
  itemsPerPage = 20;
  showCategoryManager = false;

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private supportService: SupportService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.role = localStorage.getItem('role');

    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.currentPage = 1;
      this.loadArticles();
    });

    this.loadCategories();
    this.loadArticles();
  }

  loadCategories(): void {
    this.supportService.getKbCategories().subscribe({
      next: (res: any) => {
        this.categories = res.response?.data || [];
      },
      error: () => {}
    });
  }

  openCategoryManager(): void {
    this.showCategoryManager = true;
  }

  onCategoryManagerBack(): void {
    this.showCategoryManager = false;
    this.loadCategories();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadArticles(): void {
    this.loading = true;
    this.spinner.show('kb-list-spinner');
    const params: any = {
      page: this.currentPage,
      limit: this.itemsPerPage
    };
    if (this.categoryFilter) {
      params['category'] = this.categoryFilter;
    }
    if (this.searchQuery) {
      params['search'] = this.searchQuery;
    }

    this.supportService.getArticles(params).subscribe({
      next: (res: any) => {
        this.articles = res.response?.data?.articles || res.response?.data || [];
        this.totalCount = res.response?.data?.total || this.articles.length;
        this.loading = false;
        this.spinner.hide('kb-list-spinner');
      },
      error: (err: any) => {
        this.loading = false;
        this.spinner.hide('kb-list-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to load articles');
      }
    });
  }

  onFilterChange(): void {
    this.currentPage = 1;
    this.loadArticles();
  }

  onSearchChange(): void {
    this.searchSubject.next(this.searchQuery);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadArticles();
  }

  getExcerpt(html: string): string {
    if (!html) { return ''; }
    const text = html.replace(/<[^>]*>/g, '').trim();
    return text.length > 150 ? text.substring(0, 150) + '...' : text;
  }

  navigate(id: string): void {
    this.router.navigate(['/support/articles', id]);
  }

  navigateToNew(): void {
    this.router.navigate(['/support/articles/new']);
  }
}
